import * as React from "react";

interface KVListComponentItemProps {
  key: string;
  itemKey?: string;
  value: any;
  valueUrl?: string;
  htmlAttrs?: any;
}

const KVListComponentItem = ({ itemKey, value, valueUrl, htmlAttrs = {} }: KVListComponentItemProps) => (
  <li className="kv-list__item">
    <span className="kv-list__key">{itemKey}</span>
    <span className="kv-list__value">
      {valueUrl ? (
        <a href={valueUrl} className="link link--inverted" {...htmlAttrs}>
          {value}
        </a>
      ) : (
        value
      )}
    </span>
  </li>
);

interface KVListComponentProps {
  tabKey: string; // FIXME: This is not used by the component, but set at use sites…
  items: KVListComponentItemProps[];
}

const KVListComponent = ({ items }: KVListComponentProps) => (
  <ul className="page-header__list kv-list kv-list--inverted">
    {items.map(({ key, value, valueUrl, htmlAttrs }) => (
      <KVListComponentItem key={key} itemKey={key} value={value} valueUrl={valueUrl} htmlAttrs={htmlAttrs} />
    ))}
  </ul>
);

export default KVListComponent;
